import { InitialState } from 'Container/App/interface';
import getSalesChannel, { isValidSalesChannel } from 'Container/App/helpers/getSalesChannel';
import getActiveSubscriptionId from 'Container/App/helpers/getActiveSubscriptionId';
import getFlow from 'Container/App/helpers/getFlow';
import getIsXsellEligible from 'Container/App/helpers/getIsXsellEligible';
import getAtomicId from 'Container/App/helpers/getAtomicId';
import { getCookie } from '@vfde-sails/utils';

const getCustomerConfig = (): InitialState['customerConfig'] => {
    const salesChannel = getSalesChannel();
    const activeSubscriptionId = (isValidSalesChannel(salesChannel) && getActiveSubscriptionId(salesChannel)) || null;

    return {
        flow: getFlow(),
        salesChannel,
        activeSubscriptionId,
        atomicId: getAtomicId(),
        selectedRedplusId: null,
        isXSellEligible: getIsXsellEligible(),
        hasCashback: !!getCookie('adv_cb'),
    };
};

export default getCustomerConfig;
